import React, { lazy } from 'react';

const PurchasePolicySubmenu = lazy(() =>
  import('../PurchasePolicy/PurchasePolicySubmenu').then(module => ({
    default: module.PurchasePolicySubmenu,
  })),
);

const POBTaxSchemeForm = lazy(() =>
  import('../PurchasePolicy/POBTaxSchemeForm').then(module => ({
    default: module.POBTaxSchemeForm,
  })),
);

const RFQPolicyForm = lazy(() =>
  import('../PurchasePolicy/RFQPolicyForm').then(module => ({
    default: module.RFQPolicyForm,
  })),
);

const PurchasePolicyRoutes = [
  {
    props: {
      exact: true,
      path: '/company-setup/submenu/:CompanyID/purchase-policy',
    },
    component: <PurchasePolicySubmenu />,
  },
  {
    props: {
      exact: true,
      path: '/company-setup/submenu/:CompanyID/purchase-policy/pob-tax-scheme',
    },
    component: <POBTaxSchemeForm />,
  },
  {
    props: {
      exact: true,
      path: '/company-setup/submenu/:CompanyID/purchase-policy/rfq-policy',
    },
    component: <RFQPolicyForm />,
  },
];

export default PurchasePolicyRoutes;
